import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Mamá de un Golden',
    text: 'Hice el patrón del Golden Retriever para el cumpleaños de mi hermana. Cuando lo vio, lloró. Jamás pensé que un patrón iba a generar eso.'
  }, {
    name: 'Sofía R.',
    role: 'Emprendedora Crochet',
    text: 'Mis clientas enloquecieron cuando empecé a ofrecer mascotas personalizadas. Este ebook se pagó solo con el primer pedido.'
  }, {
    name: 'Elena V.',
    role: 'Amante de los gatos',
    text: 'Las instrucciones son clarísimas. Yo hago amigurumis hace años pero nunca había encontrado patrones tan detallados con los rasgos reales de la raza.'
  }];
  return <section id="testimonios" className="py-10 md:py-16 bg-linen" data-id="element-378">
      <div className="max-w-5xl mx-auto px-4" data-id="element-379">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-380">
          <p className="text-sm font-bold tracking-[0.2em] text-copper uppercase mb-4" data-id="element-381">
            Lo que dicen quienes ya tejieron
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-382">
            Amigurumis que emocionan de verdad
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-383">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="etsy-card p-7" data-id="element-384">
              <div className="flex gap-0.5 mb-4" data-id="element-385">
                {[...Array(5)].map((_, j) => <Star key={j} size={15} className="text-amber-400 fill-amber-400" data-id="element-386" />)}
              </div>
              <p className="text-gray-600 italic mb-6 leading-relaxed text-sm" data-id="element-387">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 border-t border-gray-50 pt-4" data-id="element-388">
                <div className="w-9 h-9 rounded-full bg-cream flex items-center justify-center font-bold text-copper text-xs" data-id="element-389">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-390">
                  <h4 className="font-bold text-deep-brown text-sm" data-id="element-391">
                    {t.name}
                  </h4>
                  <p className="text-xs text-gray-400" data-id="element-392">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}